module.exports = __webpack_public_path__ + "media/night.7fb179de.mp3";